const { dateUtil } = require("../../utils");

export const columns = [
  {
    title: "Name",
    key: "name",
    render: (user) => (
      <p>
        {user.first_name}&nbsp;{user.last_name}
      </p>
    ),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Phone No",
    dataIndex: "phone_no",
    key: "phone_no",
  },
  {
    title: "Location",
    dataIndex: "location",
    key: "location",
  },
  {
    title: "Total Savings",
    dataIndex: "noOfSavings",
    key: "noOfSavings",
  },
  {
    title: "Total investments",
    dataIndex: "noOfInvestments",
    key: "noOfInvestments",
  },
  // {
  //   title: "Total Loans",
  //   dataIndex: "noOfLoanApplications",
  //   key: "noOfLoanApplications",
  // },
  {
    title: "Registered On",
    dataIndex: "created_at",
    key: "created_at",
    render: (theDate) => <p>{dateUtil.formatFullDateTime(theDate)}</p>,
  },
  // {
  //   title: "Delete",
  //   dataIndex: "",
  //   key: "y",
  // },
  {
    title: "More",
    dataIndex: "",
    key: "x",
  },
];
